var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fixupFalsyValues } from './operations/property-filter.js';
export function collectionReducer(state, action) {
    var newState = __assign({}, state);
    switch (action.type) {
        case 'selection':
            newState.selectedItems = action.selectedItems;
            break;
        case 'filtering':
            newState.currentPageIndex = 1;
            newState.filteringText = action.filteringText;
            break;
        case 'sorting':
            newState.currentPageIndex = 1;
            newState.sortingState = action.sortingState;
            break;
        case 'pagination':
            newState.currentPageIndex = action.pageIndex;
            break;
        case 'property-filtering':
            newState.currentPageIndex = 1;
            newState.propertyFilteringQuery = action.query;
            break;
    }
    return newState;
}
export function createActions(_a) {
    var dispatch = _a.dispatch, collectionRef = _a.collectionRef;
    return {
        setFiltering: function (filteringText) {
            dispatch({ type: 'filtering', filteringText: filteringText });
            collectionRef.current && collectionRef.current.scrollToTop();
        },
        setSorting: function (state) {
            dispatch({ type: 'sorting', sortingState: state });
            collectionRef.current && collectionRef.current.scrollToTop();
        },
        setCurrentPage: function (pageIndex) {
            dispatch({ type: 'pagination', pageIndex: pageIndex });
            collectionRef.current && collectionRef.current.scrollToTop();
        },
        setSelectedItems: function (selectedItems) {
            dispatch({ type: 'selection', selectedItems: selectedItems });
        },
        setPropertyFiltering: function (query) {
            dispatch({ type: 'property-filtering', query: query });
            collectionRef.current && collectionRef.current.scrollToTop();
        },
    };
}
export function createSyncProps(options, _a, actions, collectionRef, _b) {
    var _c;
    var filteringText = _a.filteringText, sortingState = _a.sortingState, selectedItems = _a.selectedItems, currentPageIndex = _a.currentPageIndex, propertyFilteringQuery = _a.propertyFilteringQuery;
    var pagesCount = _b.pagesCount, actualPageIndex = _b.actualPageIndex, allItems = _b.allItems;
    var empty = options.filtering
        ? allItems.length
            ? options.filtering.noMatch
            : options.filtering.empty
        : null;
    empty = options.propertyFiltering
        ? allItems.length
            ? options.propertyFiltering.noMatch
            : options.propertyFiltering.empty
        : empty;
    var filteringOptions = options.propertyFiltering
        ? options.propertyFiltering.filteringProperties.reduce(function (acc, property) {
            Object.keys(allItems.reduce(function (acc, item) {
                acc['' + fixupFalsyValues(item[property.key])] = true;
                return acc;
            }, {})).forEach(function (value) {
                if (value !== '') {
                    acc.push({
                        propertyKey: property.key,
                        value: value,
                    });
                }
            });
            return acc;
        }, [])
        : [];
    return {
        collectionProps: __assign(__assign(__assign({ empty: empty }, (options.sorting
            ? {
                onSortingChange: function (_a) {
                    var detail = _a.detail;
                    actions.setSorting(detail);
                },
                sortingColumn: sortingState === null || sortingState === void 0 ? void 0 : sortingState.sortingColumn,
                sortingDescending: sortingState === null || sortingState === void 0 ? void 0 : sortingState.isDescending,
            }
            : {})), (options.selection
            ? {
                onSelectionChange: function (_a) {
                    var selectedItems = _a.detail.selectedItems;
                    actions.setSelectedItems(selectedItems);
                },
                selectedItems: selectedItems,
                trackBy: options.selection.trackBy,
            }
            : {})), { ref: collectionRef }),
        filterProps: {
            filteringText: filteringText,
            onChange: function (_a) {
                var filteringText = _a.detail.filteringText;
                actions.setFiltering(filteringText);
            },
        },
        propertyFilterProps: {
            query: propertyFilteringQuery,
            onChange: function (_a) {
                var query = _a.detail;
                actions.setPropertyFiltering(query);
            },
            filteringProperties: ((_c = options.propertyFiltering) === null || _c === void 0 ? void 0 : _c.filteringProperties) || [],
            filteringOptions: filteringOptions,
        },
        paginationProps: {
            currentPageIndex: actualPageIndex !== null && actualPageIndex !== void 0 ? actualPageIndex : currentPageIndex,
            // pagesCount is always calculated when options.pagination is present
            pagesCount: pagesCount,
            onChange: function (_a) {
                var currentPageIndex = _a.detail.currentPageIndex;
                actions.setCurrentPage(currentPageIndex);
            },
        },
    };
}
